<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      <yo-help class="mg-r-15" lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
      <yo-button
        class="mg-r-20"
        label="AJOUTER"
        tooltip=" Ajouter un composant"
        iconClass="fa fa-plus"
        [disabled]="!gds.canModify(yoProduit)"
        (onClick)="enableDisplaySearchPanel()">
      </yo-button>

      <span class="mg-r-20">
      <p-dropdown
        [options]="uniteDeProductionList"
        [filter]="true"
        [style]="{'max-width':'200px','width':'200px'}"
        optionLabel="libelle"
        [(ngModel)]="selectedUniteDeProduction"
        (ngModelChange)="onChangeSelectedUniteDeProduction($event)">
      </p-dropdown>
    </span>

      <strong>RECETTE pour
        <input
          type="number"
          pKeyFilter="pint"
          class="platesNumber"
          name="platesNumber"
          min="0"
          max="1000"
          [ngModel]="yoProduit?.recetteNbPortions"
          (ngModelChange)="setPlatesNumberModelValue($event)">
        {{ libelleUT }}(s)
      </strong>
    </div>
  </dxi-item>
  <dxi-item location="after">
    <div class="d-flex flex-row align-items-center">
      <!--selection vue quantite / cout -->
      <p-selectButton class="mg-r-20" [options]="views" [ngModel]="selectedView"
                      (ngModelChange)="setViewModelValue($event)">
      </p-selectButton>

      <yo-button
        class="mg-r-5"
        iconClass="fas fa-print"
        (onClick)="imprimerFicheTechnique()"
        tooltip="Impression de la fiche technique">
      </yo-button>

      <!--enregistrer la fiche technique-->
      <yo-button
        tooltip="Enregistrer la recette"
        type="submit"
        iconClass="fas fa-save"
        buttonClass="cta-success"
        (onClick)="save()"
        [disabled]="!canModify()"></yo-button>
    </div>
  </dxi-item>
</dx-toolbar>

<p-table [columns]="cols"
         [value]="rowsPd"
         [scrollable]="true"
         [scrollHeight]="utils.scrollHeightContent(350)"
         styleClass="p-datatable-sm"
         (onRowReorder)="onRowReorder(rowsPd,cellsMap,$event)"
         dataKey="id">

  <!--COLGROUP-->
  <ng-template pTemplate="colgroup" let-columns>
    <colgroup>
      <ng-container *ngFor="let col of columns" [ngSwitch]="col.field">

        <col *ngSwitchCase="'actions'" style="width:88px" [style.text-align]="'left'">
        <col *ngSwitchCase="'composants'" style="width:493px" [style.text-align]="'left'">
        <ng-container *ngIf="hasRightsIDistri">
          <col *ngSwitchCase="'conditionneAPart'" style="width:120px" [style.text-align]="'left'">
        </ng-container>
        <col *ngSwitchCase="'codes'" style="width:143px" [style.text-align]="'left'">
        <col *ngSwitchCase="'tauxPerte'" style="width:149px" [style.text-align]="'right'"
             [style.white-space]="'nowrap'">
        <col *ngSwitchCase="'prixAchat'" style="width:159px" [style.text-align]="'right'">
        <col *ngSwitchCase="'uniteDeMesure'" style="width:91px" [style.text-align]="'right'">
        <col *ngSwitchDefault style="width:137px" [style.text-align]="'right'">

      </ng-container>

    </colgroup>
  </ng-template>


  <!--HEADER-->
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns; trackBy:utils.trackByFn" [pSortableColumn]="col.field"
          title="{{col.tooltip}}">
        <ng-container [ngSwitch]="col.field">

          <ng-container *ngSwitchCase="'actions'">
            {{ col.header }}
          </ng-container>

          <ng-container *ngSwitchCase="'composants'">
            {{ col.header }}
          </ng-container>

          <ng-container *ngIf="hasRightsIDistri">
            <ng-container *ngSwitchCase="'conditionneAPart'">
              {{ col.header }}
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'codes'">
            {{ col.header }}
          </ng-container>

          <ng-container *ngIf="useTauxPerte">
            <ng-container *ngSwitchCase="'tauxPerte'">
              {{ col.header }}
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'prixAchat'">
            {{ col.header }}
          </ng-container>

          <ng-container *ngSwitchCase="'uniteDeMesure'">
            {{ col.header }}
          </ng-container>

          <ng-container *ngSwitchDefault>
            <div style="display: inline-block;">
              {{ col.header }}
            </div>
            <div style="display: inline-block;float:right;">

              <!--n'afficher le bouton de duplication que s'il y a au moins 2 convives-->
              <ng-container *ngIf="!utils.isCollectionNullOrEmpty(colsPd) && colsPd.length>1">
                <i class="fas fa-xs fa-copy cursor" (click)="enableDisplayDuplication(col.field)"
                   title="Dupliquer {{col.header}} sur les autres convives"></i>
              </ng-container>

            </div>

          </ng-container>

        </ng-container>
      </th>
    </tr>
  </ng-template>

  <!--BODY-->
  <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
    <tr [pReorderableRow]="index">
      <td *ngFor="let col of columns; trackBy:utils.trackByFn">

        <ng-container [ngSwitch]="col.field">


          <ng-container *ngSwitchCase="'actions'">
            <i *ngIf="gds.canModify(yoProduit)" [class]="classDeplacerComponent()"
               title="Déplacer le composant"
               pReorderableRowHandle
            >
            </i>
            <i *ngIf="!gds.canModify(yoProduit)" [class]="classDeplacerComponent()"
               title="Déplacer le composant"
            >
            </i>

            <yo-cell-button (yoNavigation)="removeComponent(rowData)"
                            [yoTooltipShowDelay]="500"
                            [yoSmall]="true"
                            yoTextAlign="center"
                            yoIconClass="fa fa-trash"
                            yoTooltip="Enlever le composant"
                            [yoDisabled]="!gds.canModify(yoProduit)"
            ></yo-cell-button>

          </ng-container>

          <ng-container *ngSwitchCase="'composants'">

            <a class="cursorPn" (click)="openFicheTechnique(rowData)">

              <div class="d-flex flex-row">
                <yo-icon-produitfab [fabrique]="rowData.fabrique"></yo-icon-produitfab>
                <i *ngIf="rowData.erreurPrix && !rowData.sansAppro"
                   class="fas fa-exclamation-triangle danger-color mg-r-5 mg-l-5 align-self-center"
                   [title]="rowData.messageErreurPrix">
                </i>

                <i *ngIf="rowData?.saisonnalites?.length > 0 || rowData.noMatchingSaisonnalite"
                   [class]="rowData?.horsSaisonnalite ? 'fas fa-calendar danger-color  mg-r-5 align-self-center' : 'fas fa-calendar-check mr-2 align-self-center'"
                   id="saisonnalite-{{rowData.id}}"></i>
                <dx-tooltip
                  target="#saisonnalite-{{rowData.id}}"
                  showEvent="mouseenter"
                  hideEvent="mouseleave">
                  <div *dxTemplate="let _ = data; of: 'content'" style="white-space: pre-line">
                    {{getSaisonnalitesLabel(rowData.saisonnalites)}}
                  </div>
                </dx-tooltip>

                <div *ngIf="!rowData.subtitution">
                  <span class="firstcol-label">{{ rowData.libelle }}</span>
                  <span class="firstcol-decli"> {{ rowData.declinaison.libelle }} </span>
                </div>
                <div *ngIf="rowData.subtitution">
                  <span class="mg-r-5 line-through">{{ rowData.pdOriginalLibelle }}</span>
                  <i class="fas fa-arrow-right mg-r-5"></i>
                  <span>{{ rowData.libelle }}</span>
                </div>
              </div>

            </a>
          </ng-container>

          <ng-container *ngIf="hasRightsIDistri">
            <ng-container *ngSwitchCase="'conditionneAPart'">
              <ng-container *ngTemplateOutlet="tplConditionneAPart;context:{rowData:rowData}">
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'codes'">
            {{ rowData.code }}
          </ng-container>

          <ng-container *ngSwitchCase="'tauxPerte'">
            <div class="d-flex flex-row align-items-center mb-1">
              <input
                class="quantite mg-r-2"
                type="number"
                pKeyFilter="pnum"
                [ngModel]="getCellTauxPerte(rowData)"
                (ngModelChange)="setTauxPerte(rowData, $event)"
                [disabled]="!gds.canModify(yoProduit)">
              <span class="genlabel-color" style="white-space: nowrap; font-size: 12px "> % </span>
            </div>
          </ng-container>


          <ng-container *ngSwitchCase="'prixAchat'">
            <div style="text-align: right;">{{ (rowData.udpPrixAchat ? rowData.udpPrixAchat : rowData.prixAchat) | currency:'EUR':'symbol':'1.4-4' }}
              / {{ rowData?.uniteDeMesure.libelle }}
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'uniteDeMesure'">

            <!-- on  affiche la quantité en kg dans le cas d'une sous recette-->
            <ng-container *ngIf="rowData.fabrique">
              <div>
                <div> {{ rowData?.uniteDeMesure.libelle }}</div>
                <div class="badge badge-secondary font-10">(sous recette)</div>
              </div>

            </ng-container>
            <ng-container *ngIf="!rowData.fabrique">
              {{ rowData?.uniteDeMesure.libelle }}
            </ng-container>

          </ng-container>

          <ng-container *ngSwitchDefault>
            <!-- Quand utilisateur n'a pas les droits IDistri le col.field ci-dessous n'est pas l'id de produit declinaison mais 'conditionneAPart' -->
            <ng-container *ngIf="col.field !== 'conditionneAPart'">
              <ng-container
                *ngTemplateOutlet="tplCell;context:{cell:getCell(rowData?.id,col.field),rowData:rowData}"></ng-container>
            </ng-container>
          </ng-container>

        </ng-container>

      </td>
    </tr>
  </ng-template>

  <!--FOOTER-->
  <ng-template pTemplate="footer">
    <ng-container
      *ngTemplateOutlet="tplTotalCout;context:{pdDeclines:colsPd,view:selectedView}">
    </ng-container>
  </ng-template>
</p-table>


<!--TEMPLATE CELLULE-->
<ng-template #tplCell let-cell="cell" let-rowData="rowData">

  <!-- COUTS MATIERES-->
  <ng-container *ngIf="selectedView === 'cout'">
    <ng-container
      *ngTemplateOutlet="tplCout;context:{cell:cell,row:rowData}"></ng-container>
  </ng-container>

  <!--QUANTITES-->
  <ng-container *ngIf="selectedView === 'quantite'">
    <ng-container
      *ngTemplateOutlet="tplQuantite;context:{cell:cell,rowData:rowData}"></ng-container>
  </ng-container>

</ng-template>

<!--TEMPLATE COUTS TOTAUX-->
<ng-template #tplTotalCout let-pdDeclines="pdDeclines" let-view="view">
  <tr *ngIf="view==='cout'">
    <td [attr.colspan]="cols.length - colsPd.length" style="text-align: right; vertical-align: top;">
      <div style="text-align: right; white-space: nowrap;">
        Coût matière / {{ libelleUT }}
      </div>
      <ng-container *ngIf="yoProduit?.meal">
        <div style="text-align: right; white-space: nowrap;">
          Prix de vente / {{ libelleUT }}
        </div>
        <div style="text-align: right; white-space: nowrap;">
          Marge
        </div>
      </ng-container>
    </td>
    <ng-container *ngFor="let pdDecline of pdDeclines">
      <td style="white-space: nowrap; vertical-align: top; text-align: right;">
        <div style="white-space: nowrap; text-align: right">
          {{ getCoutProduitDecline(pdDecline) |  currency:'EUR':'symbol':'1.4-4' }} /{{ libelleUT }}
        </div>
        <ng-container *ngIf="yoProduit?.meal">
          <div style="display: flex; align-items: center;">
            <input
              #prixVente
              type="number"
              [disabled]="false"
              [value]="getPrixDeVente(pdDecline)"
              (change)="setPrixDeVente(pdDecline, prixVente.value)"
              style="flex: 1; min-width: 50px;"
            />
            <span style="white-space: nowrap; margin-left: 2px;">€</span>
          </div>
          <div style="white-space: nowrap;">
            {{ margeToString(pdDecline) }}
          </div>
        </ng-container>
      </td>
    </ng-container>
  </tr>

  <ng-container *ngIf="view==='quantite'">
    <tr>
      <td [attr.colspan]="cols.length - colsPd.length" style="text-align: right; vertical-align: middle;">
        <div class="d-flex flex-column align-items-end">
          <div style="white-space: nowrap;">Poids brut pour 1 UT:</div>
          <div class="font-size-gramme" style="white-space: nowrap;">(en gramme)</div>
        </div>
      </td>
      <ng-container *ngFor="let pdDecline of pdDeclines">
        <td style="text-align: left;">
          {{ getPoidsBrut(pdDecline)| number: '1.0-2':'fr' }} g
        </td>
      </ng-container>
    </tr>

    <tr>
      <td [attr.colspan]="cols.length - colsPd.length" style="text-align: right; vertical-align: middle;">
        <div class="d-flex flex-row align-items-center justify-content-end">
          <yo-button
            class="mg-r-10"
            iconClass="fas fa-copy"
            (onClick)="copyRawWeightToNetWeight()"
            tooltip="Report du poids brut pour 1 UT au niveau du poids net pour 1 UT pour toutes les déclinaisons">
          </yo-button>
          <div class="d-flex flex-column align-items-end">
            <div style="white-space: nowrap;">Poids net pour 1 UT:</div>
            <div class="font-size-gramme" style="white-space: nowrap;">(en gramme)</div>
          </div>
        </div>
      </td>
      <ng-container *ngFor="let pdDecline of pdDeclines">
        <td style="text-align: left;">
          <input
            class="quantite mg-r-2"
            type="number"
            pKeyFilter="pnum"
            [ngModel]="pdDecline?.totalPoidsNetRecetteUT"
            (ngModelChange)="seTotalPoidsNetRecetteUt(pdDecline, $event)"
            [disabled]="!gds.canModify(yoProduit)">
        </td>
      </ng-container>
    </tr>

    <tr *ngIf="useTauxPerte">
      <td [attr.colspan]="cols.length - colsPd.length" style="text-align: right; vertical-align: middle;">
        <div class="d-flex flex-row align-items-center justify-content-end">
          <yo-button
            class="mg-r-10"
            iconClass="fas fa-copy"
            (onClick)="applyCalculatedPoidsNet()"
            tooltip="Report du poids calculé avec le taux de perte au niveau du poids net pour toutes les déclinaisons">
          </yo-button>
          <div class="d-flex flex-column align-items-end">
            <div style="white-space: nowrap;">Poids net pour 1 UT avec taux de perte:</div>
            <div class="font-size-gramme" style="white-space: nowrap;">(en gramme)</div>
          </div>
        </div>
      </td>
      <ng-container *ngFor="let pdDecline of pdDeclines">
        <td style="text-align: left;">
          <input
            class="quantite mg-r-2"
            type="number"
            pKeyFilter="pnum"
            [ngModel]="calculatePoidsNetWithTauxPerte(pdDecline)"
            [disabled]="true">
        </td>
      </ng-container>
    </tr>

  </ng-container>
</ng-template>


<!--TEMPLATE COUTS-->
<ng-template #tplCout let-cell="cell" let-row="row">
  <div
    style="color:slategray; font-size: 14px;text-align: right;">{{ getPrixAchatComposant(cell, row) |  currency:'EUR':'symbol':'1.4-4' }}
    / {{ this.yoProduit.uniteDeMesure.libelle }}
  </div>
</ng-template>

<!--TEMPLATE QUANTITES-->
<ng-template #tplQuantite let-cell="cell" let-rowData="rowData">
  <div style="display: inline-block;width:70px;" [title]="tooltipQuantiteEnKg(cell)"
  >

    <input
      class="quantite mg-r-2"
      type="number"
      pKeyFilter="pnum"
      [ngModel]="getCellModelValue(cell)"
      (ngModelChange)="setCellModelValue(cell,$event)"
      [disabled]="!gds.canModify(yoProduit) || cell.subtitution">
  </div>
  <div style="display: inline; width:auto;">
    <em class="genlabel-color" style="font-size: 12px">{{ uniteQuantiteHelper(cell) }}</em>
  </div>


</ng-template>

<!-- TEMPLATE CONDITIONNE A PART -->
<ng-template #tplConditionneAPart let-cells="cells" let-rowData="rowData">
  <div *ngIf="rowData.fabrique" style="display: inline-block;width:70px;"
  >

    <input
      class="checkbox mg-r-2"
      type="checkbox"
      [ngModel]="getConditionneAPartLigne(rowData.id)"
      (ngModelChange)="setConditionneAPartValue(rowData.id, $event)"
      [disabled]="!gds.canModify(yoProduit)"
    />

  </div>

</ng-template>


<!--PANEL DE DUPLICATION RECETTE-->
<p-dialog [(visible)]="displayDuplication"
          [contentStyle]="{'overflow':'visible'}"
          [modal]="true"

          (onHide)="onHideDuplication()"
          [style]="{width: '800px', minWidth: '800px'}"
          [dismissableMask]="false">


  <!--HEADER-->
  <ng-template pTemplate="header">
    <div class="p-dialog-title">
      <i class="fas fa-copy mg-r-5"></i>Copier la recette vers d'autres convives
    </div>
  </ng-template>

  <!--CONTENU-->
  <div class="row" *ngIf="!utils.isNullOrEmpty(selectedSourceProduitDecline)">
    <div class="col-md-auto">
      Recette {{ selectedSourceProduitDecline.declinaison.libelle }}   <strong class="genlabel">à copier vers</strong>
    </div>
    <div class="col">
      <ng-container *ngFor="let target of getTargetsCopy(selectedSourceProduitDecline)">
        <div>
          <p-checkbox name="duplication" [value]="target.id" [(ngModel)]="selectedTargetsId"
                      [label]="target.declinaison.libelle"></p-checkbox>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <i class="fas fa-exclamation-triangle danger-color mg-r-5"></i><em>La duplication ne sera effective que
      lorsque vous aurez enregistré la recette.</em>
    </div>
  </div>

  <!--FOOTER-->
  <ng-template pTemplate="footer">
    <yo-button (onClick)="duplicate(selectedSourceProduitDecline, selectedTargetsId)" iconClass="fas fa-copy"
               label="Copier"></yo-button>
    <yo-button (onClick)="onHideDuplication()"
               buttonClass="cta-inner-delete"
               iconClass="fas fa-times" label="Fermer"></yo-button>
  </ng-template>

</p-dialog>


<!--PANEL DE RECHERCHE DE COMPOSANTS-->
<p-dialog [(visible)]="displaySearchPanel"
          [contentStyle]="{'overflow':'visible'}"
          [modal]="true"
          (onHide)="onHideSearchPanel()"
          [style]="{width: '1200px', minWidth: '1200px',height:'540px'}">

  <!--HEADER-->
  <ng-template pTemplate="header">
    <div class="p-dialog-title">
      <i class="fas fa-search-plus mg-r-5"></i>AJOUTER DES COMPOSANTS À LA RECETTE
    </div>
  </ng-template>

  <!--CONTENU-->
  <yo-ft-search-panel [udpId]="selectedUniteDeProduction === undefined ? 0 : selectedUniteDeProduction.id  "
                      [produit]="yoProduit"></yo-ft-search-panel>
</p-dialog>

<dx-popup
  [showTitle]="true"
  [title]="'IMPRIMER LA FICHE TECHNIQUE'"
  [(visible)]="displayPrintPanel"
  [width]="850"
  [height]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHiding)="onHidePrintPanel()"
>
  <div>
    <yo-list
      [data]="colsPd"
      [selectedItems]="selectedPd"
      [searchEnabled]="true"
      [selectionMode]="'all'"
      displayValue="declinaison.libelle"
      (onValueChange)="onChangeSelectedPd($event)">
    </yo-list>
  </div>
  <div class="custom-button-container-right">
    <div>
      <yo-button label="Valider" class="mg-r-5" iconClass="fas fa-check" [disabled]="selectedPd.length === 0"
                 (onClick)="exportPdf()"></yo-button>
      <yo-button label="Annuler" buttonClass="cta-inner-delete" iconClass="fas fa-times"
                 (onClick)="onHidePrintPanel()"></yo-button>
    </div>
  </div>
</dx-popup>
